import Cookies from "universal-cookie";
import { api, apiClient, uploadFile } from  "../api/client"

const cookies = new Cookies();

/**
 * Legacy AJAX Config - backwards compatibility
 */
export const ajaxconfig = () => ({
  headers: {
    Authorization: `Bearer ${cookies.get("auth_key")}`,
    email: cookies.get("email"),
    authenticated: cookies.get("authenticated"),
  },
});

// Legacy adapter
export const legacyApiCall = async (url, data = null, method = "get") => {
  try {
    const config = ajaxconfig();
    const response = await api({
      method,
      url: url.replace("https://cbt-lms.cbthost.com/api/v1/", "/"),
      data,
      headers: config.headers,
    });
    return response.data;
  } catch (error) {
    console.error("Legacy API call failed:", error);
    throw error;
  }
};

// Central exports
export { api, apiClient, uploadFile };
